import registry from "../../content/registry/case-studies.json";

export type CaseStudyLink = {
  label: string;
  url: string;
};

export type CaseStudyOutcomeKind =
  | "public-source"
  | "qualified-portfolio-outcome";

export type CaseStudyOutcomeEvidence = {
  kind: CaseStudyOutcomeKind;
  label: string;
  description: string;
  claimIds: string[];
};

export type CaseStudy = {
  id: string;
  experienceRoleId: string;
  dateRange: string;
  theme: string;
  title: string;
  context: string;
  myRole: string;
  teamAndPartners: string[];
  approachAndDecisions: string[];
  outcomeAndEvidence: CaseStudyOutcomeEvidence[];
  claimIds: string[];
  sourceLinks: CaseStudyLink[];
};

export type CaseStudiesPage = {
  heading: string;
  intro: string;
  experienceLink: {
    label: string;
    href: string;
  };
};

export type CaseStudiesRegistry = {
  schemaVersion: string;
  page: CaseStudiesPage;
  studies: CaseStudy[];
};

export const caseStudies = registry as CaseStudiesRegistry;

export const caseStudyCards = caseStudies.studies;
